import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "stickyTop", void 0);
    _defineProperty(_this, "zIndex", void 0);
    _defineProperty(_this, "className", void 0);
    _defineProperty(_this, "active", false);
    _defineProperty(_this, "position", '');
    _defineProperty(_this, "isSticky", false);
    _defineProperty(_this, "width", 'auto');
    _defineProperty(_this, "height", 'auto');
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "mounted",
    value: function mounted() {
      this.height = this.$el.getBoundingClientRect().height.toString() + 'px';
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "activated",
    value: function activated() {
      this.handleScroll();
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "sticky",
    value: function sticky() {
      if (this.active) {
        return;
      }
      this.position = 'fixed';
      this.active = true;
      this.width = this.width + 'px';
      this.isSticky = true;
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      if (!this.active) {
        return;
      }
      this.position = '';
      this.width = 'auto';
      this.active = false;
      this.isSticky = false;
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var width = this.$el.getBoundingClientRect().width;
      this.width = width.toString() + 'px' || 'auto';
      var offsetTop = this.$el.getBoundingClientRect().top;
      if (offsetTop < this.stickyTop) {
        this.sticky();
        return;
      }
      this.handleReset();
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      if (this.isSticky) {
        this.width = this.$el.getBoundingClientRect().width.toString() + 'px';
      }
    }
  }]);
}(Vue);
__decorate([Prop({
  default: 0
})], default_1.prototype, "stickyTop", void 0);
__decorate([Prop({
  default: 1
})], default_1.prototype, "zIndex", void 0);
__decorate([Prop({
  default: ''
})], default_1.prototype, "className", void 0);
default_1 = __decorate([Component({
  name: 'Sticky'
})], default_1);
export default default_1;